export default __webpack_public_path__ + "static/media/Andrea_Gullick_AHV_In_Moms_We_Trust.c24945bb.jpg";